/* eslint-disable react-refresh/only-export-components */
import React, { useEffect, useState } from 'react';
import { useSrOnlyStyles } from '@/theme/srOnly';

export type Politeness = 'polite' | 'assertive';

type Listener = (message: string, politeness: Politeness) => void;

const listeners = new Set<Listener>();

export function announce(message: string, politeness: Politeness = 'polite'): void {
  listeners.forEach((listener) => {
    try {
      listener(message, politeness);
    } catch (error) {
      console.error('LiveRegion listener error:', error);
    }
  });
}

export function LiveRegion(): React.ReactElement {
  const styles = useSrOnlyStyles();
  const [politeMessage, setPoliteMessage] = useState('');
  const [assertiveMessage, setAssertiveMessage] = useState('');

  useEffect(() => {
    let politeTimeout: number | null = null;
    let assertiveTimeout: number | null = null;
    const listener: Listener = (message, politeness) => {
      if (politeness === 'assertive') {
        if (assertiveTimeout !== null) {
          clearTimeout(assertiveTimeout);
        }
        setAssertiveMessage('');
        assertiveTimeout = setTimeout(() => setAssertiveMessage(message), 50);
      } else {
        if (politeTimeout !== null) {
          clearTimeout(politeTimeout);
        }
        setPoliteMessage('');
        politeTimeout = setTimeout(() => setPoliteMessage(message), 50);
      }
    };
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
      if (politeTimeout !== null) {
        clearTimeout(politeTimeout);
      }
      if (assertiveTimeout !== null) {
        clearTimeout(assertiveTimeout);
      }
    };
  }, []);

  return (
    <>
      <div className={styles.srOnly} role="status" aria-live="polite" aria-atomic="true">
        {politeMessage}
      </div>
      <div className={styles.srOnly} role="alert" aria-live="assertive" aria-atomic="true">
        {assertiveMessage}
      </div>
    </>
  );
}
